import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";



const initialState = {
    isLoading: false,
    isRefresh: false,
    appearanceData: {},
    goldRateData: {},
    activeCountries: {},
    errorMsg: "",
    isError: false
}


export const getAppearances = createAsyncThunk('getAppearances', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getAppearances();
        if (status === 200) {
            //get categories data
            dispatch(setAppearance(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const getGoldRate = createAsyncThunk('getGoldRate', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getGoldRate();
        if (status === 200) {
            //get categories data
            dispatch(setGoldRate(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const getActiveCountries = createAsyncThunk('getActiveCountries', async (_, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getActiveCountries();
        if (status === 200) {
            return data;
        }

    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const homeSlice = createSlice({
    name: "appearances",
    initialState,
    reducers: {

        setAppearance: (state, action) => {
            state.appearanceData = action.payload
        },
        setGoldRate: (state, action) => {
            state.goldRateData = action.payload
        },
        setRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        }
    },
    extraReducers: (builder) => {

        // Categories
        builder.addCase(getAppearances.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getAppearances.fulfilled, (state, action) => {
            state.isLoading = false
            state.appearanceData = action.payload
        })
        builder.addCase(getAppearances.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })


        // Countries
        builder.addCase(getActiveCountries.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getActiveCountries.fulfilled, (state, action) => {
            state.isLoading = false
            state.activeCountries = action.payload
        })
        builder.addCase(getActiveCountries.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
    }
})

export const {
    setRefresh,
    setAppearance,
    setGoldRate
} = homeSlice.actions

export default homeSlice.reducer;